import React from 'react';

export default function CardGrid({ items, numbered = false }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {items.map((it, i) => (
        <div key={it.title} className="bg-ivory rounded-card p-7 border border-brown/10">
          {numbered && <div className="text-eyebrow uppercase text-gold font-medium mb-2">0{i + 1}</div>}
          <h3 className="font-serif text-warm-black mb-3">{it.title}</h3>
          <p className="text-body text-muted">{it.text}</p>
        </div>
      ))}
    </div>
  );
}